<div>
  <h1 class="text-2xl font-bold mb-4">Detalhes do vendedor</h1>

  @if (error) {
  <app-alert [type]="'danger'">{{ error }}</app-alert>
  } @if (loading) {
  <div class="mb-4">
    <app-loading size="large" color="primary" />
  </div>
  } @if (!loading && sellerInfo) {
  <div class="mb-6">

    <div class="overflow-x-auto rounded-lg border border-neutral-300 dark:border-neutral-700">
      <table class="min-w-full text-sm border-collapse">
        <tbody>
          <tr class="even:bg-neutral-50 dark:even:bg-neutral-900">
            <th
              class="w-52 text-left font-semibold px-3 py-2 border-b border-neutral-200 dark:border-neutral-700"
            >
              ID
            </th>
            <td class="px-3 py-2 border-b border-neutral-200 dark:border-neutral-700">
              {{ sellerInfo.id }}
            </td>
          </tr>

          <tr class="even:bg-neutral-50 dark:even:bg-neutral-900">
            <th
              class="text-left font-semibold px-3 py-2 border-b border-neutral-200 dark:border-neutral-700"
            >
              Nome
            </th>
            <td class="px-3 py-2 border-b border-neutral-200 dark:border-neutral-700">
              {{ sellerInfo.name }}
            </td>
          </tr>

          <tr class="even:bg-neutral-50 dark:even:bg-neutral-900">
            <th
              class="text-left font-semibold px-3 py-2 border-b border-neutral-200 dark:border-neutral-700"
            >
              Email
            </th>
            <td class="px-3 py-2 border-b border-neutral-200 dark:border-neutral-700">
              {{ sellerInfo.email }}
            </td>
          </tr>

          <tr class="even:bg-neutral-50 dark:even:bg-neutral-900">
            <th
              class="text-left font-semibold px-3 py-2 border-b border-neutral-200 dark:border-neutral-700"
            >
              Role
            </th>
            <td class="px-3 py-2 border-b border-neutral-200 dark:border-neutral-700">
              {{ sellerInfo.role }}
            </td>
          </tr>

          <tr class="even:bg-neutral-50 dark:even:bg-neutral-900">
            <th
              class="text-left font-semibold px-3 py-2 border-b border-neutral-200 dark:border-neutral-700"
            >
              Salesman
            </th>
            <td class="px-3 py-2 border-b border-neutral-200 dark:border-neutral-700">
              {{ sellerInfo.salesMan }}
            </td>
          </tr>

          <tr class="even:bg-neutral-50 dark:even:bg-neutral-900">
            <th
              class="text-left font-semibold px-3 py-2 border-b border-neutral-200 dark:border-neutral-700"
            >
              Loja
            </th>
            <td class="px-3 py-2 border-b border-neutral-200 dark:border-neutral-700">
              {{ `${sellerInfo.storeId} - ${sellerInfo.storeDescription} (${sellerInfo.storeName})` }}
            </td>
          </tr>

          <tr class="even:bg-neutral-50 dark:even:bg-neutral-900 align-top">
            <th
              class="text-left font-semibold px-3 py-2 border-b border-neutral-200 dark:border-neutral-700"
            >
              Price list
            </th>
            <td class="px-3 py-2 border-b border-neutral-200 dark:border-neutral-700">
                @for (pl of sellerInfo.priceList; track pl) {
                <p>{{ pl }}</p>
                } @empty {
                <p class="italic text-neutral-500">Sem price list.</p>
                }
            </td>
          </tr>

          <tr class="even:bg-neutral-50 dark:even:bg-neutral-900 align-top">
            <th
              class="text-left font-semibold px-3 py-2 border-b border-neutral-200 dark:border-neutral-700"
            >
              Product lines
            </th>
            <td class="px-3 py-2 border-b border-neutral-200 dark:border-neutral-700">
                @for (pl of sellerInfo.productLines; track pl) {
                <p>{{ pl }}</p>
                } @empty {
                <p class="italic text-neutral-500">Sem product lines.</p>
                }
            </td>
          </tr>

          <tr class="even:bg-neutral-50 dark:even:bg-neutral-900">
            <th
              class="text-left font-semibold px-3 py-2 border-b border-neutral-200 dark:border-neutral-700"
            >
              Criado em
            </th>
            <td class="px-3 py-2 border-b border-neutral-200 dark:border-neutral-700">
              {{ sellerInfo.createdAt }}
            </td>
          </tr>

          <tr class="even:bg-neutral-50 dark:even:bg-neutral-900">
            <th
              class="text-left font-semibold px-3 py-2 border-b border-neutral-200 dark:border-neutral-700"
            >
              Atualizado em
            </th>
            <td class="px-3 py-2 border-b border-neutral-200 dark:border-neutral-700">
              {{ sellerInfo.updatedAt }}
            </td>
          </tr>

          <tr class="even:bg-neutral-50 dark:even:bg-neutral-900">
            <th
              class="text-left font-semibold px-3 py-2 border-b border-neutral-200 dark:border-neutral-700"
            >
              Autorizado
            </th>
            <td class="px-3 py-2 border-b border-neutral-200 dark:border-neutral-700">
              {{ sellerInfo.authorized ? 'Sim' : 'Não' }}
            </td>
          </tr>

          <tr class="even:bg-neutral-50 dark:even:bg-neutral-900">
            <th
              class="text-left font-semibold px-3 py-2 border-b border-neutral-200 dark:border-neutral-700"
            >
              Permite carrinho novo
            </th>
            <td class="px-3 py-2 border-b border-neutral-200 dark:border-neutral-700">
              {{ sellerInfo.enabledNewCart ? 'Sim' : 'Não' }}
            </td>
          </tr>

          <tr class="even:bg-neutral-50 dark:even:bg-neutral-900">
            <th
              class="text-left font-semibold px-3 py-2 border-b border-neutral-200 dark:border-neutral-700"
            >
              Expedition pending
            </th>
            <td class="px-3 py-2 border-b border-neutral-200 dark:border-neutral-700">
              {{ sellerInfo.expeditionPending ? 'Sim' : 'Não' }}
            </td>
          </tr>

          <tr class="even:bg-neutral-50 dark:even:bg-neutral-900">
            <th
              class="text-left font-semibold px-3 py-2 border-b border-neutral-200 dark:border-neutral-700"
            >
              Golden products
            </th>
            <td class="px-3 py-2 border-b border-neutral-200 dark:border-neutral-700">
              {{ sellerInfo.goldenProducts ? 'Sim' : 'Não' }}
            </td>
          </tr>

          <tr class="even:bg-neutral-50 dark:even:bg-neutral-900">
            <th class="text-left font-semibold px-3 py-2">Venda pinpad remota</th>
            <td class="px-3 py-2">
              {{ sellerInfo.isPinPadRemoteSale ? 'Sim' : 'Não' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="mb-6 space-y-1">
    <app-accordion>
      <app-accordion-item id="manage-seller" icon="user-plus" label="Gerenciar Cadastro">
        <div class="space-y-4">
          <h2 class="text-lg font-semibold">Dados para Alteração</h2>

          <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
            <div class="space-y-1">
              <label class="text-xs font-semibold uppercase text-neutral-500"> Store ID </label>
              <input
                type="text"
                class="w-full border border-neutral-300 dark:border-neutral-700 rounded px-2 py-1 text-sm bg-white dark:bg-neutral-900"
                [(ngModel)]="editableData.storeId"
                name="storeId"
              />
            </div>

            <div class="space-y-1">
              <label class="text-xs font-semibold uppercase text-neutral-500"> Autorizado </label>
              <div class="flex items-center gap-2 text-sm">
                <input
                  type="checkbox"
                  [(ngModel)]="editableData.authorized"
                  name="authorized"
                  class="w-4 h-4"
                />
                <span>{{ editableData.authorized ? 'Sim' : 'Não' }}</span>
              </div>
            </div>

            <div class="space-y-1">
              <label class="text-xs font-semibold uppercase text-neutral-500">
                Golden products
              </label>
              <div class="flex items-center gap-2 text-sm">
                <input
                  type="checkbox"
                  [(ngModel)]="editableData.goldenProducts"
                  name="goldenProducts"
                  class="w-4 h-4"
                />
                <span>{{ editableData.goldenProducts ? 'Ativo' : 'Inativo' }}</span>
              </div>
            </div>
          </div>

          <div class="space-y-2">
            <div class="flex items-center justify-between">
              <h3 class="text-sm font-semibold">Caixas (cashier)</h3>
              <app-button color="primary" size="small" rounded="full" (click)="onAddCashierRow()">
                Adicionar caixa
              </app-button>
            </div>

            <div class="overflow-x-auto border border-neutral-300 dark:border-neutral-700 rounded">
              <table class="min-w-full text-xs">
                <thead class="bg-neutral-100 dark:bg-neutral-800">
                  <tr>
                    <th class="px-2 py-1 text-left">Número</th>
                    <th class="px-2 py-1 text-left">Store ID</th>
                    <th class="px-2 py-1">&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  @for (c of editableData.cashier; track c; let i = $index) {
                  <tr class="even:bg-neutral-50 dark:even:bg-neutral-900">
                    <td class="px-2 py-1">
                      <input
                        type="number"
                        class="w-full border border-neutral-300 dark:border-neutral-700 rounded px-1 py-0.5 bg-white dark:bg-neutral-900"
                        [(ngModel)]="editableData.cashier[i].Number"
                        [name]="'cashierNumber-' + i"
                      />
                    </td>
                    <td class="px-2 py-1">
                      <input
                        type="text"
                        class="w-full border border-neutral-300 dark:border-neutral-700 rounded px-1 py-0.5 bg-white dark:bg-neutral-900"
                        [(ngModel)]="editableData.cashier[i].StoreId"
                        [name]="'cashierStoreId-' + i"
                      />
                    </td>
                    <td class="px-2 py-1 text-center">
                      <app-button
                        color="danger"
                        size="small"
                        rounded="full"
                        (click)="onRemoveCashierRow(i)"
                      >
                        Remover
                      </app-button>
                    </td>
                  </tr>
                  } @empty {
                  <tr>
                    <td colspan="3" class="px-2 py-2 text-center text-neutral-500">
                      Nenhum caixa cadastrado.
                    </td>
                  </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>

          <div class="space-y-2">
            <div class="flex items-center justify-between">
              <h3 class="text-sm font-semibold">Price list</h3>
              <app-button color="primary" size="small" rounded="full" (click)="onAddPriceListRow()">
                Adicionar price list
              </app-button>
            </div>

            <div class="space-y-1">
              @for (pl of editableData.priceList; track i; let i = $index) {
              <div class="flex gap-2 items-center">
                <input
                  type="text"
                  class="flex-1 border border-neutral-300 dark:border-neutral-700 rounded px-2 py-1 text-sm bg-white dark:bg-neutral-900"
                  [(ngModel)]="editableData.priceList[i]"
                  [name]="'priceList-' + i"
                />
                <app-button
                  color="danger"
                  size="small"
                  rounded="full"
                  (click)="onRemovePriceListRow(i)"
                >
                  Remover
                </app-button>
              </div>
              } @empty {
              <p class="text-xs text-neutral-500">Nenhuma price list cadastrada.</p>
              }
            </div>
          </div>

          <div class="space-y-2">
            <div class="flex items-center justify-between">
              <h3 class="text-sm font-semibold">Product lines</h3>
              <app-button
                color="primary"
                size="small"
                rounded="full"
                (click)="onAddProductLineRow()"
              >
                Adicionar product line
              </app-button>
            </div>

            <div class="space-y-1">
              @for (pl of editableData.productLines; track i; let i = $index) {
              <div class="flex gap-2 items-center">
                <input
                  type="text"
                  class="flex-1 border border-neutral-300 dark:border-neutral-700 rounded px-2 py-1 text-sm bg-white dark:bg-neutral-900"
                  [(ngModel)]="editableData.productLines[i]"
                  [name]="'productLine-' + i"
                />
                <app-button
                  color="danger"
                  size="small"
                  rounded="full"
                  (click)="onRemoveProductLineRow(i)"
                >
                  Remover
                </app-button>
              </div>
              } @empty {
              <p class="text-xs text-neutral-500">Nenhuma product line cadastrada.</p>
              }
            </div>
          </div>

          <div class="border-t border-neutral-200 dark:border-neutral-700 pt-4 space-y-2">
            @if (sellerInfo.existsInVtex) {
            <p class="text-sm">
              Usuário já existe na VTEX. Você pode atualiza-lo.
            </p>
            <div class="flex flex-wrap gap-2">
              <app-button
                color="primary"
                rounded="full"
                [loading]="workingLoading"
                (click)="openConfirmModal('update')"
              >
                Atualizar
              </app-button>
            </div>
            } @else {
            <p class="text-sm">
              O usuário não existe no MasterData da VTEX. Deseja criá-lo com os dados informados?
            </p>
            <app-button
              color="primary"
              rounded="full"
              [loading]="workingLoading"
              (click)="openConfirmModal('create')"
            >
              Criar
            </app-button>
            }
          </div>
        </div>
      </app-accordion-item>
    </app-accordion>
  </div>
  }
</div>

<app-modal #entityModal [title]="modalTitle" class="min-w-[1366px]">
  <div class="max-h-[70vh] overflow-auto min-w-[1366px]">
    @if (modalIsLoading) {
    <app-loading size="large" color="primary" />
    } @else if (modalError) {
    <app-alert [type]="'danger'">{{ modalError }}</app-alert>
    } @else if (modalOriginalModel && modalModifiedModel) {
    <p>Alterações:</p>
    <div style="min-height: 600px; min-width: 1366px">
      <ngx-monaco-diff-editor
        style="min-height: 600px"
        [originalModel]="modalOriginalModel"
        [modifiedModel]="modalModifiedModel"
        [options]="diffOptions"
      ></ngx-monaco-diff-editor>
    </div>
    } @else { @if (modalOriginalModel) {
    <p>Entidade antes:</p>
    <pre class="text-xs whitespace-pre-wrap">{{ modalOriginalModel }}</pre>
    } @if (modalModifiedModel) {
    <p>Entidade depois:</p>
    <pre class="text-xs whitespace-pre-wrap">{{ modalModifiedModel }}</pre>
    } }
  </div>
</app-modal>
<app-modal #confirmModal [title]="confirmModalTitle" class="min-w-[900px]">
  <div class="max-h-[70vh] overflow-auto space-y-4">
    <p class="text-sm text-neutral-600 dark:text-neutral-300">
      Revise as alterações antes de confirmar. Apenas os campos abaixo serão enviados para o MasterData.
    </p>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <h3 class="text-sm font-semibold mb-1">Valores atuais</h3>
        <pre class="text-xs bg-neutral-100 dark:bg-neutral-800 p-2 rounded max-h-64 overflow-auto">
{{ confirmBeforeJson }}
        </pre>
      </div>
      <div>
        <h3 class="text-sm font-semibold mb-1">Novos valores</h3>
        <pre class="text-xs bg-neutral-100 dark:bg-neutral-800 p-2 rounded max-h-64 overflow-auto">
{{ confirmAfterJson }}
        </pre>
      </div>
    </div>

    <div class="flex justify-end gap-2 pt-2">
      <app-button rounded="full" size="small" (click)="onCancelConfirm()">
        Cancelar
      </app-button>
      <app-button
        color="primary"
        rounded="full"
        size="small"
        [loading]="workingLoading"
        (click)="onConfirmAction()"
      >
        Confirmar
      </app-button>
    </div>
  </div>
</app-modal>

